module.exports = __webpack_public_path__ + "media/raise_capital/dropzone_upload_image-93e38995.png";